import { render, staticRenderFns } from "./PhoneCopySuggestion.vue?vue&type=template&id=a30478ac&scoped=true&"
import script from "./PhoneCopySuggestion.vue?vue&type=script&lang=ts&"
export * from "./PhoneCopySuggestion.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneCopySuggestion.vue?vue&type=style&index=0&id=a30478ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30478ac",
  null
  
)

export default component.exports